<template>
  <div class="matrix_layoutMain container" :class="getClassNameContainer">
    <div class="row">
      <div class="col-md-12">
        <appUploadTable alwaysShow="true"></appUploadTable>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";

export default {};
</script>
